import { createRouter, createWebHashHistory } from 'vue-router'
//import Home from '@/views/HomeView.vue'
import Playlist from '@/views/PlaylistView.vue'
import PlaylistEditorView from '@/views/playlist/PlaylistEditorView.vue'
import PlaylistSong from '@/views/PlaylistSongView.vue'
import PlaylistPrintView from '@/views/playlist/PlaylistPrintView.vue'
//import PresentationRemoteView from '@/views/PresentationRemoteView.vue'
import ErrorView from '@/views/ErrorView.vue'
import AdminView from '@/views/admin/AdminView.vue'
import DashboardView from '@/views/admin/DashboardView.vue'
import ManagerUserView from '@/views/admin/ManagerUserView.vue'
import SettingsView from '@/views/admin/SettingsView.vue'
import SearchManagementView from '@/views/admin/SearchManagementView.vue'
import UpdateRequiredView from '@/views/UpdateRequiredView.vue'
import ProfileView from '@/views/user/ProfileView.vue'
import SongView from '@/views/song/SongView.vue'
import CreateSongView from '@/views/song/CreateSongView.vue'
import ListSongView from '@/views/song/ListSongView.vue'
import ArtistView from '@/views/artist/ArtistView.vue'
import ListArtistView from '@/views/artist/ListArtistView.vue'
import CreateEditArtistView from '@/views/artist/CreateEditArtistView.vue'
import TeamView from '@/views/team/TeamView.vue'
import ListTeamView from '@/views/team/ListTeamView.vue'
import CreateEditTeamView from '@/views/team/CreateEditTeamView.vue'
import userStore, { verifyIam } from "@/store/user.store.js"
import appStore from "@/store/app.store.js"
import PlaylistListView from '@/views/playlist/PlaylistListView.vue'
import ListPlaylistView from '@/views/playlist/ListPlaylistView.vue'
import ScheduleView from '@/views/schedule/ScheduleView.vue'
import TestView from '@/views/TestView.vue'
import RealTimePresentationView from '@/views/RealTimePresentationView.vue'
import PlaylistNew from '@/components/playlist/PlaylistNew.vue'
import TermsView from '@/views/legal/TermsView.vue'
import PrivacyPolicyView from '@/views/legal/PrivacyPolicyView.vue'
import CopyrightPolicyView from '@/views/legal/CopyrightPolicyView.vue'
import LoginView from '@/views/LoginView.vue'
import { isNativePlatform, updateStatusBarTheme } from '@/utils/capacitor.js'
import tourService from '@/service/tour/tour.service.js'

const routes = [
    {
        id: 'login',
        path: '/login',
        name: 'Login',
        component: LoginView,
        meta: {
            layout: 'EmptyLayout',
            requiresAuth: false
        }
    },
    {
        id: 'home',
        path: '/',
        name: 'Dashboard',
        component: PlaylistListView,
    },
    {
        id: 'profile',
        path: '/profile',
        name: 'Profile',
        component: ProfileView
    },
    {
        id: 'song',
        path: '/song',
        name: 'Song',
        component: SongView,
        // meta: {
        //     requiresAuth: true
        // },
        children: [
            {
                path: '',
                component: ListSongView
            },
            {
                path: 'new',
                component: CreateSongView
            },
            {
                path: ':id',
                component: CreateSongView
            },
        ]
    },
    {
        id: 'artist',
        path: '/artist',
        name: 'Artist',
        component: ArtistView,
        // meta: {
        //     requiresAuth: true
        // },
        children: [
            {
                path: '',
                component: ListArtistView
            },
            {
                path: 'new',
                component: CreateEditArtistView
            },
            {
                path: ':id',
                component: CreateEditArtistView
            },
        ]
    },
    {
        id: 'team',
        path: '/team',
        name: 'Team',
        component: TeamView,
        children: [
            {
                path: '',
                component: ListTeamView
            },
            {
                path: 'new',
                component: CreateEditTeamView
            },
            {
                path: ':id',
                component: CreateEditTeamView
            },
        ]
    },
    {
        id: 'schedule',
        path: '/schedule',
        name: 'Schedule',
        component: ScheduleView
    },
    {
        id: 'playlist:list',
        name: 'Playlist List',
        path: '/playlist',
        component: ListPlaylistView
    },
    {
        id: 'playlist:edit',
        name: 'Playlist Edit',
        path: '/playlist/:id',
        component: Playlist,
    },
    {
        id: 'playlist:editor',
        name: 'Playlist Editor',
        path: '/playlist/:id/editor',
        component: PlaylistEditorView,
    },
    {
        id: 'playlist:editor',
        name: 'New Playlist',
        path: '/playlist/new',
        component: PlaylistNew,
    },
    {
        id: 'playlist:view',
        name: 'Playlist Songs',
        path: '/playlist/:id/song/:songId?',
        component: PlaylistSong
    },
    {
        id: 'playlist:print',
        name: 'Playlist Print',
        path: '/playlist/:id/print',
        component: PlaylistPrintView,
        meta: {
            layout: 'EmptyLayout',
        }
    },
    {
        id: 'presentation:controller',
        name: 'Presentation Controller',
        path: '/playlist/:id/presentation/remote',
        component: RealTimePresentationView,
    },
    {
        path: '/playlist/:id/presentation',
        redirect: to => ({ name: 'Presentation Controller', params: { id: to.params.id } }),
    },
    {
        id: 'admin',
        name: 'Admin',
        path: '/admin',
        component: AdminView,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: '',
                component: DashboardView
            },
            {
                path: 'users',
                component: ManagerUserView
            },
            {
                path: 'search',
                component: SearchManagementView
            },
            {
                path: 'settings',
                component: SettingsView
            }
        ]
    },
    {
        name: 'Test',
        path: '/test',
        component: TestView,
    },
    {
        id: 'error',
        name: 'Error',
        path: '/error',
        component: ErrorView,
        meta: {
            layout: 'EmptyLayout',
        }
    },
    {
        id: 'update_required',
        name: 'Update Required',
        path: '/update-required',
        component: UpdateRequiredView,
        meta: {
            layout: 'EmptyLayout',
        }
    },
    {
        id: 'terms',
        name: 'Terms of Service',
        path: '/terms',
        component: TermsView,
        meta: {
            requiresAuth: false,
            layout: 'EmptyLayout'
        }
    },
    {
        id: 'privacy',
        name: 'Privacy Policy',
        path: '/privacy',
        component: PrivacyPolicyView,
        meta: {
            requiresAuth: false,
            layout: 'EmptyLayout'
        }
    },
    {
        id: 'copyright',
        name: 'DMCA & Copyright',
        path: '/copyright',
        component: CopyrightPolicyView,
        meta: {
            requiresAuth: false,
            layout: 'EmptyLayout'
        }
    },
    {
        id: 'dmca',
        name: 'DMCA Policy',
        path: '/dmca',
        component: CopyrightPolicyView,
        meta: {
            requiresAuth: false,
            layout: 'EmptyLayout'
        }
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/',
    }

]

const router = createRouter({ history: createWebHashHistory(), routes })

router.beforeEach(async (to) => {
    appStore.state.currentView = to.name;

    // Clean up active tour and backdrops on navigation
    try {
        tourService.destroy();
    } catch (e) {
        // Safe fallback
    }

    // Immediately allow public routes (e.g. Terms of Service, Privacy Policy, DMCA, Error)
    const publicRoutes = ['Login', 'Terms', 'PrivacyPolicy', 'CopyrightPolicy', 'Error', 'UpdateRequired'];
    if (publicRoutes.includes(to.name) || (to.meta && to.meta.requiresAuth === false)) {
        return true;
    }

    if (!userStore.state.userInfo) {
        try {
            await userStore.dispatch("info");
        } catch (e) {
            console.warn("User info fetch failed:", e);
        }
    }

    const userInfo = userStore.state.userInfo;
    if (!userInfo) {
        if (isNativePlatform()) {
            return { name: 'Login' };
        } else {
            window.location.href = '/login';
            return false;
        }
    }

    // Only routes explicitly marked with requiresAuth (e.g., /admin) require IAM permission checks
    if (to.meta && to.meta.requiresAuth) {
        if (verifyIam(userInfo, to.path)) {
            return true;
        } else {
            appStore.dispatch('error', { message: 'You not authorized to access this resource', error: '403 - Forbidden' });
            return { name: 'Error' };
        }
    }

    return true;
});

// Persiste a última rota autenticada e sincroniza estilo de barra de status nativa
router.afterEach((to) => {
    updateStatusBarTheme(to.name === 'Login');
    try {
        if (userStore.state.userInfo && to.path !== '/login' && !to.path.startsWith('/error')) {
            localStorage.setItem('triad_last_route', to.fullPath);
        }
    } catch (e) {
        // storage indisponível — segue sem persistir
    }
});

router.onError((error) => {    console.error('Router chunk loading error:', error);
    const isChunkLoadFailed = /Loading chunk .* failed/i.test(error.message) || 
                              /fetch/i.test(error.message) || 
                              /dynamically imported module/i.test(error.message) ||
                              /css/i.test(error.message) ||
                              error.name === 'ChunkLoadError';
    
    if (isChunkLoadFailed) {
        const now = Date.now();
        const lastReload = parseInt(sessionStorage.getItem('triad_asset_reload') || '0', 10);
        if (now - lastReload > 8000) {
            sessionStorage.setItem('triad_asset_reload', now.toString());
            const url = new URL(window.location.href);
            url.searchParams.set('u', now.toString());
            console.warn("Auto-reload prevented for debugging:", url.toString());
            // window.location.replace(url.toString());
        }
    }
});

export default router